module.exports = __webpack_public_path__ + "img/101.5e29adcf.jpg";